<template lang="html">
  <div class="fadeIn content-wrapper">

    <h2><b>{{$t('users.users')}}</b></h2>
    <div class="user-details">
      <UserDetail class="detail"
                :user="userSelected"
                v-show="userSelected && userSelected.user_id"
                :scCanUpdate="scCanUpdate"
                :isAdminOrOps="isAdminOrOperationsUser()" />
      <div v-if="isAdminOrOperationsUser()" class="card detail card-golf-course" v-show="userSelected && userSelected.user_id">
        <div class="card-header">
          <h5><b>{{$t('facility.facilitiesAssociated')}}</b></h5>
          <button v-b-modal.md-add-facility
                  id="btn-associate-facility" 
                  class="btn btn-primary medium">
            {{ $t('facility.addFacility') }}
          </button>
        </div>
        <div class="card-body md-scrollbar md-theme-default p-0">
          <table class="table" v-if="user_facilities && user_facilities.length > 0">
            <thead>
              <tr>
                <th>{{$t('facility.facilityName')}}</th>
                <th>{{$t('facility.facilityCode')}}</th>
                <th>{{$t('sensors.visible')}}</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(course, index) in user_facilities">
                <td align="left">{{course.name}}</td>
                <td align="left">{{course.course_code}}</td>
                <td align="left">
                  <b-icon class= "user-hidden not-pointer" v-if="course.user_hidden" icon="eye-slash-fill"></b-icon>
                  <b-icon class="user-hidden not-pointer" v-else icon="eye"></b-icon>
                </td>
                <td align="right">
                  
                  <b-icon v-if="course.course_id && course.user_hidden" @click="confirmHideUser(course, userSelected)" icon="eye" aria-hidden="true" :class="{'mr-3': true,'icon-disabled': isGroundWorxUser(userSelected.user_type.group)}"></b-icon>
                  <b-icon v-if="course.course_id && !course.user_hidden" @click="confirmHideUser(course, userSelected)" icon="eye-slash-fill" aria-hidden="true" :class="{'mr-3': true,'icon-disabled': isGroundWorxUser(userSelected.user_type.group)}"></b-icon>

                  <b-icon @click="deleteUserFromCourse(userSelected.user_id, course.course_id)" icon="trash-fill" aria-hidden="true"></b-icon>
                </td>
              </tr>
            </tbody>
          </table>
          <div v-else>
            <br>
            <span class="empty-courses">{{$t('facility.userNoFacilities')}}</span>
          </div>
        </div>
      </div>
      <div v-else class="card detail card-golf-course" v-show="userSelected && userSelected.user_id">
        <div class="card-header">
          <h5><b>{{$t('facility.facilityAssociated')}}</b></h5>
        </div>
        <div class="card-body fz-text-details">
          <table class="single_course">
            <tr>
              <td class="course-detail" align="right"><p class="card-text">{{$t('facility.facilityName')}}: </p></td>
              <td class="course-detail" align="left"><p class="card-text" v-if="userSelected.golf_courses">{{getCourse().name}}</p></td>
            </tr>
            <tr>
              <td class="course-detail" align="right"><p class="card-text">{{$t('facility.facilityCode')}}: </p></td>
              <td class="course-detail" align="left"><p class="card-text" v-if="userSelected.golf_courses" >{{getCourse().course_code}}</p></td>
            </tr>
          </table>
        </div>
      </div>

    </div>
    <UsersTable
      v-if="showTable"
      v-bind:users="usersFilter"
      :selectUser="setUserSelected"
      :fnDeleteUser="reloadTable"
      :selectedUser="userSelected"
      v-bind:loading="loadingUsersArray"
      :scCanCreate="scCanCreate"
      :scCanUpdate="scCanUpdate"
      :isAdminOrOperationsUser="isAdminOrOperationsUser"/>

    <UsersTable
      v-else
      v-bind:users="[]"
      :selectUser="setUserSelected"
      :fnDeleteUser="reloadTable"
      v-bind:loading="loadingUsersArray"
      :scCanCreate="scCanCreate"
      :scCanUpdate="scCanUpdate"
      :isAdminOrOperationsUser="isAdminOrOperationsUser"/>

  <b-modal size="lg" id="md-add-facility"
          :no-close-on-backdrop="true"
          :no-close-on-esc="true"
          :hide-header-close="true"
          :title="$t('facility.addFacility')" style="max-height: 50px; min-width: 750px; max-width: 750px; ">
    <p class="mb-3 fs-16">{{ $t('facility.facilityName') }}</p>
    <input v-model="facility_name" type="text" class="form-control mb-3">
    
    <div class="available-facilities-wrapper">
      <div class="row m-0 justify-content-around">
        <div style="display:flex; flex:1; font-weight: bold;">{{$t('facility.facilityName')}}</div>
        <div style="display:flex; flex:1; font-weight: bold;">{{$t('facility.facilityCode')}}</div>
      </div>
      
      <div class="row m-0 mb-1 justify-content-around available-facility-option"
          v-for="(facility, index) in coursesFilter" :class="{'selected-facility': isSelected(facility)}" @click="selectFacility(facility)">
        <div style="display:flex; flex:1">{{facility.name}}</div>
        <div style="display:flex; flex:1">{{facility.course_code}}</div>
      </div>
    </div>

    
    <template #modal-footer>
      <a @click="cancelAssociateFacilities" class="btn btn-secondary medium f-right mx-3"> {{ $t('general.cancel') }} </a>
        <button @click="associateFacilities" class="btn btn-primary medium" type="button"
            :disabled="loading.addingFacility">
          <span class="spinner-border spinner-border-sm" v-show="loading.addingFacility" /> {{ $t('general.add') }} </button>
    </template>
  </b-modal>
  </div>
</template>

<script>
import { isEmpty } from 'lodash';
import { deleteUserGolfCourse, getUserFacilities, hideUser, saveUserGolfCourse, getUsersCustomer } from '@/api/index';
import {
  mapState,
  mapActions,
  mapMutations,
} from 'vuex';
import SecurityComponent from '@/components/SecurityComponent.vue';
import UserDetail from '@/components/UserDetail.vue';
import UsersTable from './components/UsersTable.vue';
import { filter } from 'vuedraggable';

let usersArray = [];

export default {
  name: 'Users',
  extends: SecurityComponent,
  components: {
    UserDetail,
    UsersTable,
  },
  data() {
    return {
      user_facilities: [],
      facility_name: null,
      loading: {
        addingFacility: false,
      },
      selectedFacilities: [],
      loadingUsersArray: true,
      showTable: false,
    };
  },
  computed: {
    ...mapState('Users', ['userSelected']),
    ...mapState('Courses', {
        courses: (state) => state.courses,
      }),
    
    course() {
      return this.$store.state.course;
    },
    coursesFilter:function(){
      if(this.facility_name){
        let facility_name = this.facility_name.toLowerCase();
        const filtered = this.courses.filter(
          (course) => 
            (course.name && course.name.toLowerCase().includes(facility_name))
          );
        return this.G_sortArr(filtered, 'name');
      }
      return this.G_sortArr(this.courses, 'name');
    },
    usersFilter:function(){
      return usersArray;
    },
  },
  methods: {
    ...mapActions('Users', ['apiGetUsers']),
    ...mapActions('Courses', ['loadCourses']),
    ...mapMutations('Users', ['setUserSelected', 'setUsers']),

    isSelected(facility){
      return this.selectedFacilities.find(f => f.course_id == facility.course_id)
    },

    selectFacility(facility){
      let find = this.selectedFacilities.findIndex(f => f.course_id == facility.course_id)

      if(find == -1){
        this.selectedFacilities.push(facility)
      } else {
        this.selectedFacilities.splice(find, 1);
      }
    },

    cancelAssociateFacilities() {
      this.selectedFacilities = [];
      this.loading.addingFacility = false;
      this.$bvModal.hide('md-add-facility');
    },

    async associateFacilities() {
      if (this.selectedFacilities.length > 0) {
        this.loading.addingFacility = true;
        for (let i = 0; i < this.selectedFacilities.length; i++) {
          const facility = this.selectedFacilities[i];
          const alreadyAdded = this.user_facilities.find(f => f.course_id == facility.course_id);
          if (!alreadyAdded) {
            await this.associateFacility(facility);
          }
        }

        this.getUserFacilities(this.userSelected);

        this.selectedFacilities = [];
        this.$bvModal.hide('md-add-facility');
        this.loading.addingFacility = false;
      }
    },

    async associateFacility(facility) {
      if (this.userSelected && this.userSelected.user_id) {
        await saveUserGolfCourse(facility.course_id, this.userSelected.user_id);
      }
    },

    getCourse() {
      if (!isEmpty(this.course) && !isEmpty(this.userSelected) && this.userSelected.golf_courses) {
        const index = this.userSelected.golf_courses.findIndex(
          (c) => c.course_id === this.course.course_id,
        );
        if (index > -1) {
          return this.course;
        }
      } else if (this.userSelected.golf_courses && this.userSelected.golf_courses.length) {
        return this.userSelected.golf_courses[0];
      }
      return {};
    },
    isAdminOrOperationsUser() {
      return (this.$store.state.user.user_type.type_id == this.consts.UserType.ADMIN ||
              this.$store.state.user.user_type.type_id == this.consts.UserType.OPERATIONS);
    },

    async getUserFacilities(val){
      this.user_facilities = [];
      await getUserFacilities(val.user_id).then((resp) => {
          this.user_facilities = resp;
      });
    },

    deleteUserFromCourse(user_id, course_id) {
      if (course_id) {
        const user = this.userSelected;
        this.G_Alert_v2({ 
          style: this.consts.Style.DANGER, 
          message: this.$t('courses.delUserConfirm'),
          fnOk: () => {
            deleteUserGolfCourse(course_id, user_id)
            .then(() => {
              const index = this.userSelected.golf_courses.findIndex(
                (c) => c.course_id === course_id,
              );
              if (index > -1) {
                this.userSelected.golf_courses.splice(index, 1);
              }
            });
          }
        });
      }
    },
    isGroundWorxUser(type){
      if(type == this.consts.UserGroup.GROUNDWORX){
        return true;
      }
      return false;
    },

    confirmHideUser (course, user){
      if(user.user_type.group != this.consts.UserGroup.GROUNDWORX){
        if(course && course.course_id){
          this.G_Alert_v2({ style: this.consts.Style.DANGER, 
            message: user.hidden 
              ? this.$t('users.dyrwToShow') 
              : this.$t('users.dyrwToHide') ,
            fnOk: () => {
              var hidden = !course.user_hidden;
              hideUser(user.user_id, course.course_id, hidden).then((resp) => {
                course.user_hidden = hidden;
              });
            }
          });
        }
      }
    },

    // fnApiGetAllUsers() {
    //   this.loadingUsersArray = true;
    //   getAllUsers().then((response) => {
    //     if (response && response.users) {
    //       usersArray = response.users.filter((user) => !user.deleted);
    //       this.loadingUsersArray = false;
    //       if (usersArray.length > 0) {
    //         this.setUserSelected(usersArray[0]);
    //         this.showTable = true;
    //       }
    //     }
    //   });
    //   this.loadingUsersArray = false;
    // },

    fnApiGetUsers() {
      this.loadingUsersArray = true;
      getUsersCustomer(null).then((response) => {
        if (response && response.users) {
          usersArray = response.users.filter((user) => !user.deleted);
          this.loadingUsersArray = false;
          if (usersArray.length > 0) {
            this.setUserSelected(usersArray[0]);
            this.showTable = true;
          }
        }
      });
      this.loadingUsersArray = false;
    },
    reloadTable() {
      this.showTable = false;
      this.loadingUsersArray = true;
      this.setUserSelected({});
      window.location.reload();
    },
  },
  mounted() {
    if (process.env.VUE_APP_SENTRY_ENV === 'production') {
      this.$analytics.setCurrentScreen('Web Users');
      this.$analytics.logEvent('web_users');
    }

    this.setUserSelected({});

    if (this.$store.state.user.user_type.type_id === this.consts.UserType.ADMIN
    || this.$store.state.user.user_type.type_id === this.consts.UserType.OPERATIONS) {
      this.loadCourses();
      console.log('entra aqui?');
      this.showTable = true;
      this.loadingUsersArray = false;
    } else {
      this.fnApiGetUsers();
    }
  },
  created() {
    this.setUserSelected({});
  },
  beforeDestroy() {
    this.setUserSelected({});
    this.setUsers([]);
  },
  watch: {
    course(val) {
      if (val) {
        if (this.$store.state.user.user_type.type_id !== this.consts.UserType.ADMIN
        && this.$store.state.user.user_type.type_id !== this.consts.UserType.OPERATIONS) this.fnApiGetUsers();
      } else {
        this.setUserSelected({});
        this.setUsers([]);
      }
    },

    userSelected(val) {
      if (this.isAdminOrOperationsUser() && val.user_id && val.user_id != undefined) {
        this.getUserFacilities(val);
      }
    }
  },
};
</script>

<style lang="scss" scoped>
@import './users.scss';
</style>
